import { Observable } from 'rxjs';
import { CRUDHnadler } from '../../../domain/repositories/general/crud.handler';
import { Socio } from '../../../domain/models/socio.model';
import { Update } from '../../../domain/repositories/general/update.interface';

/**
 *Casos de uso de la entidad Socio que realizara acciones a nivel de aplicación cuando se realice la acción de actualización 
 *
 * @export
 * @class UpdateSocioUseCase
 * @implements {Update}
 */
export class UpdateSocioUseCase implements Update {
  constructor(private crudHandler: CRUDHnadler) {}

  public update(id: number, socio: Socio): Observable<Socio> {
    return this.crudHandler.update(id, socio);
  }
}
